/* eslint-disable react/no-deprecated */
import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';
import { DateTime } from 'common/utils/date';

class StarDistributionClass extends Component {
  render() {
    let options = {
      plugins: {
        tooltip: {
          mode: 'nearest',
          footerMarginTop: 10,
          callbacks: {
            title: tooltipItems => {
              return `Week of ${DateTime.fromISO(tooltipItems[0].label).toLocaleString(
                DateTime.DATE_SHORT
              )}`;
            },
            label: tooltipItem => {
              let stars =
                parseInt(tooltipItem.chart.data.datasets[tooltipItem.datasetIndex].label) > 1 ?
                  'stars'
                : 'star';
              return `${
                tooltipItem.chart.data.datasets[tooltipItem.datasetIndex].label
              } ${stars}: ${tooltipItem.formattedValue}%`;
            },
            labelColor: tooltipItem => {
              let datasetIndex = tooltipItem.datasetIndex;
              let color = tooltipItem.chart.data.datasets[datasetIndex].pointBackgroundColor;
              return { borderColor: 'transparent', backgroundColor: color };
            },
          },
        },
      },
      scales: {
        x: { display: false, stacked: true },
        y: {
          display: false,
          stacked: true,
          ticks: { max: 101 },
          grid: {
            display: true,
          },
        },
      },
    };

    return (
      <BaseChart
        id="starDistributionOverTime"
        type="line"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="created_at"
        chartHandler={this.props.chartHandler}
      />
    );
  }
}

export default StarDistributionClass;
/* eslint-enable react/no-deprecated */
